export const ACCOUNT_STATES = Object.freeze({
  nil: 'nil',
  pending: 'pending',
  approved: 'approved',
  rejected: 'rejected'
})



// WEBPACK FOOTER //
// ./src/js/const/account.const.js